import React from 'react';
import { Draggable } from '../../pages/home/Draggable';
import { Track } from '../../types';

interface TrackListProps {
  tracks: Track[];
  type: 'beat' | 'effect' | 'melody' | 'vocal';
  songName: string;
  isDeleteMode: boolean;
  onDeleteTrack: (track: Track) => void;
}

const TrackList: React.FC<TrackListProps> = ({ 
  tracks, 
  type, 
  songName, 
  isDeleteMode, 
  onDeleteTrack 
}) => {
  const typeLabels = {
    beat: '节拍',
    effect: '音效',
    melody: '旋律',
    vocal: '人声'
  };

  return (
    <div className={`${type}s tracksWrap`}>
      {tracks.map((track, track_index) => {
        const usedTracks = JSON.parse(localStorage.getItem('usedtrack') || '[]');
        const isNewTrack = track && !usedTracks.includes(track.hashValue);
        
        return (
          <React.Fragment key={track_index}>
            {track ? (
              isDeleteMode ? (
                <div className="deleteTrack">
                  <div className="track delete-mode" onClick={() => onDeleteTrack(track)}>
                    <img src={`https://oss.usecubes.cn/incredibox/assets/files/${songName}/${track.fileDirectory}/icon.svg`} alt={track.chineseName} />
                  </div>
                </div>
              ) : (
                <Draggable id={`${type}_${track_index}`}>
                  <div className={`track ${isNewTrack ? 'new' : ''}`}>
                    <img src={`https://oss.usecubes.cn/incredibox/assets/files/${songName}/${track.fileDirectory}/icon.svg`} alt={track.chineseName} />
                  </div>
                </Draggable>
              )
            ) : (
              <div className="emptyTrack">
                <div className="track"></div>
              </div>
            )}
          </React.Fragment>
        );
      })}
      <div className="trackTitle"><span>{typeLabels[type]}</span></div>
    </div>
  );
};

export default TrackList; 